<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item, index) in pageMeta.breadcrumb" :key="index">
                <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ pageMeta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="view-head">
            {{ pageMeta.title }}
            <div class="title-btn">
            </div>
        </h1>
        <div class="view-content">
            <el-card class="box-card">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="下载模板">
                        <el-button @click="download">下载模板</el-button>
                    </el-form-item>
                    <el-form-item label="上传文件">
                        <el-upload style="margin-bottom:20px;" drag :limit="1" class="upload-demo" ref="upload"
                            :action="`${$axios.defaults.baseURL}admin/temporary/importModel`"
                            :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList"
                            :on-success="onSuccess"
                            accept=".xls,.docx,.docm,.dotm,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam,.docx,.xlsx,.xlsm,.xltx"
                            :auto-upload="false">
                            <!--              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>-->
                            <i class="el-icon-upload up-box"></i>
                            <p class="upHint">
                                点击或拖拽到此处上传
                            </p>
                        </el-upload>
                        <el-button style="margin-left: 10px;" size="small" type="success"
                            @click="nextSetp">下一步</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="danger" @click="downloadErrorData"
                            v-if="error">下载错误表格</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <!-- 直连历史月采集任务 -->
        <el-dialog title="直连历史月采集任务" :visible.sync="createTaskDialogVisible" width="50%" :close-on-click-modal="false"
            @open="handleDialogOpen">
            <el-form :model="createTaskForm" label-width="120px" :rules="rules" ref="createTaskForm">

                <el-form-item label="采集月份" prop="collectMonth">
                    <el-date-picker v-model="createTaskForm.collectMonth" type="monthrange" range-separator="至"
                        start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="数据类型" prop="dataTypes">
                    <el-checkbox-group v-model="createTaskForm.dataTypes">
                        <el-checkbox label="sales">销售月报</el-checkbox>
                        <el-checkbox label="purchase">采购月报</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="任务类型" prop="taskType">
                    <el-radio-group v-model="createTaskForm.taskType" @change="handleTaskTypeChange">
                        <el-radio label="realtime">实时</el-radio>
                        <el-radio label="scheduled">定时</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="定时采集时间" prop="scheduledTime" v-if="createTaskForm.taskType === 'scheduled'">
                    <el-date-picker v-model="createTaskForm.scheduledTime" type="datetime" placeholder="选择日期时间"
                        :picker-options="scheduledTimeOptions" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-checkbox v-model="createTaskForm.splitFile">
                        拆分文件
                    </el-checkbox>

                    <el-checkbox v-model="createTaskForm.compareData" v-if="showCompareDataOption">
                        对比差异
                    </el-checkbox>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createTaskDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitCreateTask">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { exportModel } from '@/api/export';
import { multipleAddTemporary } from "@/api/index";
export default {
    name: "BatchImportTask",
    beforeCreate() {
        this.pageMeta = this.$route.meta;
        // this.email_client_id = this.$route.params.id;
    },
    data: () => ({
        fileList: [],
        form: {},
        selectedDealers: [], // 存储返回的经销商
        createTaskDialogVisible: false,
        error: false,
        loading: false,
        scheduledTimeOptions: {
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7; // 禁用今天以前的日期
        }
        },
        createTaskForm: {
            collectTargets: [],
            collectMonth: [],
            dataTypes: ['sales'],
            taskType: 'realtime',
            scheduledTime: '',
            splitFile: false,
            compareData: false
        },
        rules: {
            collectMonth: [
                { required: true, message: '请选择采集月份', trigger: 'change' }
            ],
            dataTypes: [
                { required: true, message: '请选择数据类型', trigger: 'change' }
            ],
            taskType: [
                { required: true, message: '请选择任务类型', trigger: 'change' }
            ],
            scheduledTime: [
                { required: true, message: '请选择定时采集时间', trigger: 'change' }
            ],
            splitFile: false,
            compareData: false
        },
    }),
    methods: {
        // 弹窗打开时的处理
        handleDialogOpen() {
            // 重置表单
            this.createTaskForm = {
                collectTargets: [],
                collectMonth: [],
                dataTypes: ['sales'],
                taskType: 'realtime',
                scheduledTime: '',
                splitFile: false,
                compareData: false
            };
            // 重置表单验证状态
            if (this.$refs.createTaskForm) {
                this.$refs.createTaskForm.resetFields();
            }

            // 如果是定时任务，设置默认时间为当前时间
            if (this.createTaskForm.taskType === 'scheduled') {
                this.createTaskForm.scheduledTime = new Date();
                console.log(this.createTaskForm.scheduledTime, 'this.createTaskForm.scheduledTime');
            }
        },
        // 判断是否显示对比差异选项
        showCompareDataOption() {
            return this.createTaskForm.dataTypes.includes('sales');
        },
        //下载空模板
        download() {
            exportModel();
        },
        //下一步
        nextSetp() {
            this.$refs.upload.submit();
        },
        //上传文件成功回调
        onSuccess(res, file, fileList) {
            console.log("sdfsdf")
            if (res.status == 0) {
                this.selectedDealers = res.data.list;
                if (this.selectedDealers) {
                    //是否批量导入任务来的 is_batch
                    this.createTaskDialogVisible = true;
                } else {
                    this.$message.error("上传失败");
                }
                this.error = false;
            } else if (res.status == 1) {
                this.$message.error(res.msg);
                this.error = false;
            } else if (res.status == 2) {
                this.error_path = 'api/' + res.data.error_path;
                this.$message.error('模板内容有误，请下载错误表格！');
                this.error = true;
            } else {
                this.$message.error(res.msg);
                this.error = false;
            }
            this.fileList = [];
        },
        handleTaskTypeChange(value) {
         // 如果是定时任务，设置默认时间为当前时间
         if (value === 'scheduled') {
          this.createTaskForm.scheduledTime = new Date();
          console.log(this.createTaskForm.scheduledTime, 'this.createTaskForm.scheduledTime');
         }
        },
        submitCreateTask() {
            if (this.loading) return; // 防连点
            this.loading = true;

            this.$refs.createTaskForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 添加定时采集时间验证
                        if (this.createTaskForm.taskType === 'scheduled') {
                            const now = new Date().getTime();
                            const scheduledTime = new Date(this.createTaskForm.scheduledTime).getTime();

                            if (scheduledTime <= now) {
                                this.$message.error('采集开始时间不能早于当前时间');
                                this.loading = false;
                                return;
                            }
                        }

                        // 构造请求参数
                        const parameter = {
                            client_list: JSON.stringify(this.selectedDealers.map(dealer => ({
                                client_code: dealer.client_code,
                                plugin_code: dealer.plugin_code,
                                client_name: dealer.client_name,
                                client_id: dealer.client_id
                            }))),
                            collect_start_month: `${this.createTaskForm.collectMonth[0]}-01`,
                            collect_end_month: `${this.createTaskForm.collectMonth[1]}-01`,
                            report_types: this.createTaskForm.dataTypes.map(type => {
                                return type === 'sales' ? '7' : '8';
                            }).join(','),
                            scrap_time_type: this.createTaskForm.taskType === 'realtime' ? 1 : 2,
                            is_split_file: this.createTaskForm.splitFile ? 1 : 0,
                            is_diff: this.createTaskForm.compareData ? 1 : 0
                        };

                        // 如果是定时任务，添加定时时间
                        if (parameter.scrap_time_type === 2) {
                            parameter.scrap_time = this.createTaskForm.scheduledTime;
                        }

                        const res = await multipleAddTemporary(parameter);

                        if (res.status === 0) {
                            this.$message.success(res.msg || '创建任务成功');
                            this.createTaskDialogVisible = false;
                            this.$router.go(-1);
                        } else {
                            this.$message.error(res.msg || '创建任务失败');
                        }
                    } catch (error) {
                        console.error('创建任务失败:', error);
                        this.$message.error('创建任务失败');
                    } finally {
                        this.loading = false;
                    }
                } else {
                    this.loading = false;
                }
            });
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        //下载错误数据
        downloadErrorData() {
            window.location.href = this.error_path;
        }

    }
}
</script>

<style scoped>
.upHint {
    font-size: 16px;
    margin: 0 0 4px;
    color: #adadad !important;
    font-weight: 400;
}

.upload-area>.el-upload {
    width: 100%;
}

.up-box {
    font-size: 40px;
    color: #FD8E02;
    line-height: 0;
}
</style>